<div
    class="d-flex flex-grow-1"
    [ngClass]="{
        'flex-column': isCredit,
    }"
>
    <div class="d-flex flex-row align-items-center rnpl-container">
        @if (paymentSelectedName === paymentMethodsEnum.CREDIT_CARD) {
            @if (!!paymentMethodValue) {
                <app-lib-card-type class="me-2" [cardType]="paymentMethodImage" width="2.3em" />
            }
        } @else {
            <app-lib-logo-payment-method
                [paymentMethodName]="paymentMethodImage"
                [width]="'2.3em'"
                [ngClass]="{ 'border-0': isFinance }"
            />
        }
        @if (showValue) {
            @if (paymentSelectedName === paymentMethodsEnum.CARGO_CREDIT) {
                <div class="ms-2 m-0 mat-subtitle-1 d-flex flex-row align-items-center header-text">
                    SprintPay account
                </div>
            }
            @if (isFinance || isSprintpayFlex) {
                <ng-container [ngTemplateOutlet]="sprintPayFlexTemplate" />
            }
            @if (!isCredit && paymentMethodValue && paymentSelectedName !== paymentMethodsEnum.PAYPAL) {
                <app-lib-last-four-digits [lastFourDigits]="paymentMethodValue" textClass="header-text" class="ms-3" />
            }
        }
        <!-- START: CREDIT CARD SELECTED - NO CARD FOUND -->
        @if (paymentSelectedName === paymentMethodsEnum.CREDIT_CARD && !paymentMethodValue) {
            @if (isAuthenticated) {
                <div class="ps-1 d-inline-block">
                    <small>Please select a credit card</small>
                </div>
            } @else {
                <div class="d-inline-block">
                    <i class="bi bi-exclamation-circle-fill align-items-center me-2 d-inline-block"></i
                    ><small>Please add a credit card</small>
                </div>
            }
        }
        <!-- END: CREDIT CARD SELECTED - NO CARD FOUND -->
        <!-- START: ECHECK SELECTED - NO ECHECK FOUND -->
        @if (paymentSelectedName === paymentMethodsEnum.ECHECK && !paymentMethodValue) {
            <div class="ps-1 d-inline-block">
                <small>Please select an Bank Account (ACH)</small>
            </div>
        }
        <!-- END: ECHECK SELECTED - NO ECHECK FOUND -->
    </div>
    @if (isCredit) {
        <div class="m-0 mat-subtitle-1 d-flex flex-row align-items-center gap-1 header-text mt-2">
            <span>Credit Available: </span>
            {{ paymentMethodValue | currency }}
            @if (!isEnoughCredit) {
                <mat-icon class="warning-color" [matTooltip]="insufficientCreditWarning | stripHtml">info</mat-icon>
            }
        </div>
    }
    @if (paymentSelectedName === paymentMethodsEnum.PAYPAL) {
        <div class="container-template h-100 d-flex align-items-center justify-content-center flex-column">
            <app-lib-logo-payment-method
                [paymentMethodName]="paymentMethodsEnum.PAYPAL"
                width="80px"
                alt="Paypal logo"
            />
        </div>
    }
    @if (isEnoughCredit === false && isCredit) {
        <div class="d-flex error-message mat-body-2 mt-1 header-text">
            <span class="material-symbols-outlined me-1">exclamation</span>You do not have enough credit to make your
            payment.
        </div>
    }
</div>

<ng-template #sprintPayFlexTemplate>
    <div class="ms-2 m-0 mat-subtitle-1 d-flex flex-row align-items-center rnpl-copy">
        <span class="header-text rnpl-title">SprintPay Flex</span>
        <app-rnpl-slogan></app-rnpl-slogan>
    </div>
</ng-template>
